<template>
  <el-row>
    <el-col :span="24" class="text-right">
      <el-select v-model="status" class="mr-15">
        <el-option value="all" label="Barchasi" />
        <el-option value="true" label="Aktivlar" />
        <el-option value="false" label="No aktiv" />
      </el-select>
      <el-select v-model="lang" class="mr-15">
        <el-option value="uz" label="O'zbek tilida" />
        <el-option value="ru" label="Rus tilida" />
        <el-option value="en" label="Ingliz tilida" />
      </el-select>
      <router-link to="news/add" class="el-button el-button--primary">
        Qo'shish
      </router-link>
    </el-col>
    <el-col :span="24" class="mt-15">
      <el-table :data="dataList" class="table" border>
        <el-table-column title="T/R" width="80">
          <template #default="scope">
         {{(page-1)*limit + scope.$index+1}}
        </template>
        </el-table-column>
        <el-table-column prop="title" label="Sarlavha" min-width="150">
          <template #default="scope">
            <div class="text-no-wrap-3">
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="link" label="Havola" width="180">
          <template #default="scope">
            <div class="text-no-wrap-2">
              {{ scope.row.link }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="active"
          label="Holati"
          width="150"
          align="center"
        >
          <template #default="scope">
            <el-switch
              :loading="loading"
              @change="setStatus(scope.row.id)"
              v-model="scope.row.active"
              inline-prompt
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Aktiv"
              inactive-text="No aktiv"
            />
          </template>
        </el-table-column>
        <el-table-column prop="context" label="Mazmuni" min-width="150">
          <template #default="scope">
            <div class="html-box" v-html="scope.row.context" />
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="Qo'shilgan sana"
          width="150"
          align="center"
        >
          <template #default="scope">
            {{ $moment(scope.row.created_date).format("DD.MM.YYYY HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="Amallar"
          width="200"
          align="center"
        >
          <template #default="scope">
            <el-button
              size="small"
              type="danger"
              @click="onRemove(scope.row?.id)"
            >
              O'chirish
            </el-button>
            <router-link
              class="el-button el-button--primary el-button--small"
              :to="`news/add/${scope.row?.id}`"
            >
              Taxrirlash
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="count"
          v-model:page-size="limit"
          v-model:current-page="page"
        />
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import http from "@/http";
import { ElMessage } from "element-plus";

const lang = ref("uz");
const dataList = ref([]);
const loader = ref(false);
const count = ref(0);
const page = ref(1);
const limit = ref(10);
const status = ref("all");
const onRemove = (id) => {
  loader.value = true;
  http
    .delete(`api/v1/news/${id}`)
    .then(() => {
      dataList.value = dataList.value.filter((v) => v.id !== id);
    })
    .catch(() => {
      ElMessage.error("Hatolik qayta urinib ko'ring!");
    })
    .finally(() => {
      loader.value = false;
    });
};
const setStatus = (id) => {
  loader.value = true;
  http
    .patch(`api/v2/info/news/${id}`)
    .then((res) => {
      const m = dataList.value.map((v) => {
        if (v.id === id) {
          return {
            ...v,
            active: res.data.active,
          };
        }
        return v;
      });
      dataList.value = m;
    })
    .catch(() => {
      ElMessage.error("Hatolik qayta urinib ko'ring!");
    })
    .finally(() => {
      loader.value = false;
    });
};
watchEffect(() => {
  loader.value = true;
  http
    .get("api/v1/admin/news", {
      params: {
        offset: (page.value - 1) * limit.value,
        limit: limit.value,
        active: status.value === "all" ? null : status.value,
      },
      headers: {
        hl: lang.value,
      },
    })
    .then((res) => {
      dataList.value = res.data.content;
      count.value = res.data.count;
    })
    .finally(() => {
      loader.value = false;
    });
});
</script>
<style scoped>
.mr-15 {
  margin-right: 15px;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.el-button--primary {
  text-decoration: none;
}

.html-box {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
